import * as api from './index';

export function getVehicles(query) {
    const queryString = (new URLSearchParams(query)).toString();
    return api.get(`/vehicles?${queryString}`);
}

export function getVehicle(id) {
    return api.get(`/vehicles/${id}`);
}

export function createVehicle(vehicle) {
    return api.post('/vehicles', vehicle);
}

export function updateVehicle(vehicle) {
    return api.patch(`/vehicles/${vehicle.id}`, vehicle);
}

export function setIsActiveVehicle(vehicle, isActive) {
    return api.patch(`/vehicles/${vehicle.id}/isActive`, { isActive });
}

export function softDeleteVehicle(vehicle) {
    return api.del(`/vehicles/${vehicle.id}/soft`);
}
